import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PreinvoiceService } from './preinvoice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { PreinvoiceDialogDeleteComponent } from './preinvoice-dialog-delete.component';
import { CoreComponent } from '../../../core/header/core.component';
import { WorkOrderConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import { consts } from '../../../consts';
import { InvoiceService } from '../invoice/invoice.service';
import { TableService } from '../../../shared/components/table/table.service';
import { PreinvoiceDialogWorkOrderComponent } from './preinvoice-dialog-work-order.component';
import { Utils } from '../../../shared/utils';
import { WorkOrderModel } from './work-order.model';
import * as FileSaver from 'file-saver';
import { DocumentAssignService } from '../../../modules_v2/income/shared/services/document-assign.service';

@Component({
    selector: 'convfact-work-order-list',
    templateUrl: './work-order-list.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})
export class WorkOrderListComponent implements OnInit {

  dataSource: WorkOrderModel[] = [];

  empty = false;
  ready = false;
  spinner = false;
  currentActivityUid: string = this.core.activitySelected;
  searchText: string;
  headerTable: any[] = WorkOrderConst.headerTable;


  constructor(
    private router: Router,
    private preinvoiceService: PreinvoiceService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private invoiceService: InvoiceService,
    private core: CoreComponent,
    private dummy: DummyComponent,
    private tableService: TableService,
    private documentAssign: DocumentAssignService
  ) { }

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.preinvoiceService.getAllWorkOrder().then(
      data => {
        this.tableService.set(data);
        this.dataSource = data;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      }
    );
  }

  public delete(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.dialog.open(PreinvoiceDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      }
      );
  }

  public pdf(uid: string): void {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    const workOrder = this.dataSource.filter(w => w.uid == uid)[0];

    const fileName = workOrder.orderNumber + ".pdf";

    this.invoiceService.pdfWorkOrder(uid).then(response => {
      FileSaver.saveAs(response, fileName);
    });
  }

  update(uid: string, statusId: number) {
    const workOrder = this.dataSource.filter(c => c.uid == uid)[0];

    this.preinvoiceService.updateWorkOrder(workOrder.id, { ...workOrder, statusId: statusId }).then(response => {
      this.getList();
    });
  }

  edit(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.dialog.open(PreinvoiceDialogWorkOrderComponent, {
      width: '640px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      autoFocus: false,
      data: { uid: uid }
    })
      .afterClosed().subscribe((saved: boolean) => {
        if (saved) {
          this.getList();
        }
      });
  }



  assignInvoice(uid: string) {
    if (!Utils.IsTierOne()) {
      if (!Utils.IsTierTwo()) {
        if (!Utils.IsTierFour()) {
          this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
            duration: 3000,
          });
          return;
        }
      }
    }

    this.documentAssign.assignWorkOrder({ uid }).subscribe(assigned => {
      if (assigned) this.getList();
    });
  }
  public trackByIndex(i: number) { return i; }

}
